import {View} from './view';

export class HubSpotView extends View {

    hideHubSpotSubmitButton(hsForm: any) {
        const submitBtn = this.getHtmlElementBy(hsForm, '.hs_submit.hs-submit') as HTMLSelectElement;
        if (submitBtn) {
            submitBtn.style.display = 'none';
        }
    }

    findFiles(fields: any[]): any[] {
        return Array.prototype.filter.call(fields, (field: any) => {
            return field.type === 'file' && field.files[0];
        })
        .map((field: any) => {
            return Object.assign(field.files[0], {fieldName: field.name});
        });
    }
    
}
